import { render, staticRenderFns } from "./contest.vue?vue&type=template&id=481e077e&scoped=true"
import script from "./contest.vue?vue&type=script&lang=js"
export * from "./contest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e077e",
  null
  
)

export default component.exports